import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@components/common/dialog'
import { DictType } from '@pma/types'
import { useModal } from '@stores/modal-store'
import { cn } from '@pma/utils/helpers'
import { useAuth } from '@stores/auth-store'
import useTranslator from '@hooks/use-translator'
import { Separator } from '@components/common/separator'
import WorkspaceDetails from './workspace-details'

interface InviteUserFormProps extends React.HTMLAttributes<HTMLDivElement> {}

export default function SwitchWorkSpace({ className, ...props }: InviteUserFormProps) {
  const { translate } = useTranslator()
  const modal = useModal()

  const { authConfig } = useAuth()

  const availableWorkspaces = authConfig?.companies_of_user

  const orgId = authConfig?.last_organization_id

  const closeModal = () => {
    // reset modal store
    modal.onClose()
    modal.setContext(undefined)
  }

  return (
    <Dialog open={modal.isOpen && modal.context === "workspace"} onOpenChange={closeModal}>
      <DialogContent className='max-h-[510px] overflow-auto md:max-h-[700px] md:min-w-[700px]'>
        <DialogHeader>
          <DialogTitle className='flex flex-col items-center justify-center gap-y-4 pb-2'>
            <h1 className='text-2xl font-semibold tracking-tight'>{translate("Workspaces")} </h1>
          </DialogTitle>
          <DialogDescription className='dark:text-white-fade space-y-2 pt-2 text-center font-medium text-zinc-900'>
            <div className={cn("text-muted-foreground", className)} {...props}>
              <div className='mb-4'>
                <WorkspaceDetails id={orgId} isCurrent={true} className='h-24 cursor-pointer' />
              </div>
              <Separator />
              <div className='w-full py-2 text-left'>
                <h3>{translate("Available Workspaces")}</h3>
              </div>{" "}
              {availableWorkspaces?.length > 0 ? (
                <div className='my-4 grid grid-cols-1 gap-4 md:grid-cols-2'>
                  {availableWorkspaces
                    ?.filter((val: DictType) => val.id !== orgId)
                    ?.map((workspace: DictType, index: number) => (
                      <WorkspaceDetails
                        id={workspace?.id}
                        key={index}
                        className={cn("h-24 cursor-pointer")}
                      />
                    ))}
                </div>
              ) : (
                <div className=''>{translate("No workspaces found")}</div>
              )}
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <div className='flex w-full flex-col items-center justify-center'>
            <div className='flex w-full text-xs text-slate-500'>
              <span>{translate("")} </span>
            </div>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
